import {Directive, ElementRef, HostListener, Input} from '@angular/core';

@Directive({
  selector: '[appHoverExpand]',
  exportAs: 'appHoverExpand'
})
export class HoverExpandDirective {

  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('selector') selector = '.content-card';
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('experimental') experimental = null;
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('debug') debug = null;
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('appHoverExpand') content: string;
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('showBackground') showBackground: string;

  private tooltipElement: HTMLDivElement;
  private elementTextColor: string;
  private windowWidth = 0;

  constructor(private el: ElementRef) {
  }

  @HostListener('mouseenter') mouseover() {
    if (this.isExperimental && (!this.isOverSized || !this.contentIsValid)) {
      return;
    }

    if (this.isExperimental) {
      if (!this.hasTextColor) {
        this.elementTextColor = window.getComputedStyle(this.bindingElement).color;
      }

      if (this.hasTextColor) {
        this.bindingElement.style.color = 'transparent';
      }
    }

    const tooltip = this.getTooltipElement();

    // Just in case there was one previously displayed
    this.removeTooltip();

    this.bindingElement.appendChild(tooltip);

    if (this.useBackground) {
      this.tooltipElement.style.opacity = '0';
      this.tooltipElement.style.transition = '500ms ease-in-out';
      this.tooltipElement.style.opacity = '1';
    }
  }

  @HostListener('mouseleave') mouseleave() {
    if (this.isExperimental && (!this.isOverSized || !this.contentIsValid)) {
      return;
    }

    if (this.isExperimental) {
      if (this.hasTextColor && !this.isDebugMode) {
        this.bindingElement.style.color = this.elementTextColor;
      } else if (this.isDebugMode) {
        this.bindingElement.style.color = 'red';
      }
    }


    if (!this.isDebugMode) {
      if (this.useBackground) {
        this.tooltipElement.style.opacity = '0';
        setTimeout(() => this.removeTooltip(), 500);
      } else {
        this.removeTooltip();
      }
    }
  }

  private getTooltipElement() {
    if (!this.needToCreateTooltip) {
      this.tooltipElement.style.opacity = '0';
      this.tooltipElement.style.transition = '500ms ease-in-out';
      return this.tooltipElement;
    }

    const tooltip = document.createElement('div');
    const tooltipContent = document.createElement('p');

    const elementStyle = window.getComputedStyle(this.bindingElement);
    const contentCardStyle = window.getComputedStyle(document.body.querySelector(this.selector));

    tooltipContent.innerText = this.content;

    tooltip.style.height = elementStyle.height;
    tooltip.id = 'expanded';
    tooltip.style.color = contentCardStyle.color;
    tooltip.style.backgroundColor = contentCardStyle.backgroundColor;
    tooltip.style.display = 'flex';
    tooltip.style.alignItems = 'center';

    if (!this.experimental) {
      tooltip.style.position = 'absolute';
      tooltip.appendChild(tooltipContent);

      this.tooltipElement = tooltip;
    } else {
      const boundingPoints: { x: number; y: number } = this.bindingElement.getBoundingClientRect();
      const elementMaxWidth = elementStyle.maxWidth;

      tooltipContent.style.width = '100%';
      tooltipContent.style.overflowWrap = 'break-word';
      tooltipContent.style.whiteSpace = 'pre-wrap';
      tooltipContent.style.margin = '0';

      if (this.useBackground) {
        tooltipContent.style.position = 'absolute';
        tooltipContent.classList.add('hov-tooltip-content');
        tooltipContent.style.top = '-5px';
        tooltipContent.style.left = '-5px';
        tooltipContent.style.right = '-5px';
        tooltipContent.style.padding = '5px';
        tooltip.style.right = '0';
        tooltip.style.opacity = '0';
        tooltip.style.transition = '500ms ease-in-out';
      } else {
        tooltipContent.style.padding = '0';
      }

      if (!!this.elementTextColor) {
        tooltipContent.style.color = this.elementTextColor;
      }

      tooltip.appendChild(tooltipContent);
      tooltip.style.position = 'fixed';
      tooltip.style.top = `${Math.ceil(boundingPoints.y)}px`;
      tooltip.style.left = `${Math.ceil(boundingPoints.x)}px`;
      tooltip.style.zIndex = '999999';

      if (!!elementMaxWidth && !this.useBackground) {
        tooltip.style.width = elementMaxWidth;
      } else {
        tooltip.style.maxWidth = '80vw';
      }

      this.tooltipElement = tooltip;
      this.windowWidth = document.body.offsetWidth;
    }

    return tooltip;
  }

  private removeTooltip() {
    if (this.isDebugMode && !!this.bindingElement.querySelector(`#expanded`)) {
      this.bindingElement.querySelector(`#expanded`).remove();
    }
  }

  private get isOverSized(): boolean {
    return (this.bindingElement.offsetWidth < this.bindingElement.scrollWidth);
  }

  private get isExperimental(): boolean {
    return !!this.experimental;
  }

  private get hasTextColor(): boolean {
    return !!this.elementTextColor;
  }

  private get bindingElement(): HTMLElement {
    return this.el.nativeElement;
  }

  private get needToCreateTooltip(): boolean {
    if (this.isExperimental && !!this.windowWidth) {
      return this.windowWidth !== document.body.offsetWidth || !this.tooltipElement;
    }

    return !this.tooltipElement;
  }

  private get contentIsValid(): boolean {
    return !!this.content && this.content.trim().length > 1;
  }

  private get isDebugMode(): boolean {
    return !!this.debug;
  }

  private get useBackground(): boolean {
    return !!this.showBackground;
  }
}
